import { Box,Button,Divider } from "@mui/material"
import { useState ,useEffect, useRef } from "react"
import WestIcon from '@mui/icons-material/West';
import { ApiService } from "../../API/AxiosInstance";
import { useLocation,useParams,useNavigate } from "react-router-dom"
import { IconButton, Typography } from "@mui/material"
import moment from "moment";
import { getNotificationIcons } from "../../utils/GetNotificationIcon";
import NotificationIconBox from "./NotificationIconBox";
import { retrievePriorityIcon } from "../../components/Notifications/PriorityIconText";
import PillButton from "../../components/PillButton";
import { ShimmerSkeleton } from "../../utils/SkimmerSkeleton";
import ToastAlert from "../../utils/Toaster";
import useTimeoutCleanup from "../../components/useTimeoutCleanup";
import { containerStyle, titleStyle, bodyStyle, cardStyle, headingStyle, backTextStyle } from "./NotificationList";
import BackArrow from '../../img/products/BackArrow.png';
import { isRead } from "../../utils/validation";
import { colors } from '../../Theme/tokens';
import ConfirmDeleteDialog from "../../components/ConfirmDeleteDialog ";

const NotificationDetail = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate()
    const [notification, setNotification] = useState(location.state?.notification || null);
    const userId = location.state?.userId || null;
    const [loading,setLoading] = useState(false)
    const createdDate =  notification?.createdAt ? moment(notification?.createdAt).fromNow() : ''
    const PriorityIcon = retrievePriorityIcon(Number(notification?.isPriority))
    const [toastStatus,setToastStatus] = useState({color:'',status:false,message:'',icon:''})
    const timeoutRef = useRef(null);
    const archiveStatus = notification?.userNotificationStatuses[0]?.isActive ? 'archive' : 'unarchive' 
    const [deleteModal, setDeleteModal] = useState(false);
    useTimeoutCleanup(timeoutRef);
    
    const NotificationIcon = getNotificationIcons(notification?.userNotificationStatuses[0]?.hasRead,notification?.mainCategoryId)

    useEffect(() => {
        if(id) {
            getNotificationDetail()
            if(isRead(notification)) return;
            updateNotificationStatus()
        }
    },[id])

    const getNotificationDetail = async() => {
        setLoading(true)
        try {
            const response = await ApiService().get(`notifications/${id}/users/${userId}`);
            if(response?.status === 200) {
                setNotification(response?.data?.notification)
            }

        } catch(error) {
            console.log("error ",error)
        } finally {
            setLoading(false)
        }
    }

    const updateNotificationStatus = async() => {
        try {
            const response = await ApiService().post(`notifications/${id}/users/${userId}/status/read`);
            console.log("updateNotificationStatus ",response)
        } catch(error) {
            console.log("error ",error)
        } finally {
        }
    }


    const handleHide = async () => {
        console.log("within")
        try {
            const response = await ApiService().post(`notifications/${notification.notificationId}/users/${notification?.userNotificationStatuses[0]?.userId}/${archiveStatus}/update`)
            if (response.status == 200) {
                setToastStatus({
                    color: "green",
                    status: true,
                    message: response?.data?.message,
                    icon: "tick",
                });
            }
        } catch (error) {
            setToastStatus({
                color: "red",
                status: true,
                message: error?.response?.data?.message || "Something went wrong",
                icon: "close",
            });
        } finally {
            timeoutRef.current = setTimeout(() => {
                setToastStatus({
                    color: "",
                    status: false,
                    message: "",
                    icon: "",
                });
                navigate(-1)
            }, 3000);
        }
    };

    const handleDeleteClick = () => {
        setDeleteModal(true);
    };

    const handleDeleteClose = () => {
        setDeleteModal(false);
    };

    const handleDelete = async () => {
        try {
            const response = await ApiService().post(`notifications/${notification.notificationId}/users/${notification?.userNotificationStatuses[0]?.userId}/delete`)
            console.log("statusapi ", response)
            if (response.status == 200) {
                setToastStatus({
                    color: "green",
                    status: true,
                    message: response?.data?.message,
                    icon: "tick",
                });
            }
        } catch (error) {
            setToastStatus({
                color: "red",
                status: true,
                message: error?.response?.data?.message || "Something went wrong",
                icon: "close",
            });
        } finally {
            timeoutRef.current = setTimeout(() => {
                setToastStatus({
                    color: "",
                    status: false,
                    message: "",
                    icon: "",
                });
                navigate(-1)
            }, 3000);
            handleDeleteClose()
        }
    };
  return (
    <>
        <ConfirmDeleteDialog
            open={deleteModal}
            onClose={handleDeleteClose}
            onConfirm={handleDelete}
            title="Delete Notification?"
            message="Are you sure you want to delete this Notification?"
        />
    <Box backgroundColor={colors.background.default} height="auto" sx={{...containerStyle,boxShadow:  `0px 1px 5px 0px ${colors.border.card}`}}>
        <ToastAlert  message={toastStatus?.message} status={toastStatus?.status}  color={toastStatus?.color} icon={toastStatus?.icon} closeFunc={() => setToastStatus({color:'',status:false})} />  
             <Box component="div" sx={cardStyle} mt={0.5}>
                    
                    {/* 🔹 Header */}
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 2 }}>
                      <IconButton
                          onClick={() => {
                              if (timeoutRef?.current) {
                                  clearTimeout(timeoutRef.current);
                              }
                              navigate(-1)
                          }}
                          sx={{
                              display: "flex",
                              width: "fit-content",
                              alignItems: "center",
                              gap: "11.18px",
                              padding: "10px",
                              pl: 0,
                              borderRadius: "22px",
                          }}
                      >
                          <Box component="img" src={BackArrow} />
                          <Typography sx={backTextStyle}>Back</Typography>
                      </IconButton>
                      <Typography sx={headingStyle}>Notification Details</Typography>
              </Box>
                    
       {!loading ? <Box sx={{borderRadius:"12px", padding:"24px", display:"flex", flexDirection:"column", gap:2,justifyContent:"center", boxShadow:  `0px 1px 5px 0px ${colors.border.card}`, backgroundColor:"white"}}>            
            <Box sx={{display:"flex", justifyContent:"space-between", gap:4}}>
                {/* <Typography sx={{fontSize:{xs:"20px",lg:"22px"},fontWeight:500, lineHeight:"110%",alignSelf:"center",color:"#0D0C2C"}}>{notification?.title}</Typography> */}
                <Box sx={{display:"flex",flexDirection:"column",gap:2,flex:1, width:"90%"}}>
                    <Typography sx={{...titleStyle,fontSize:{xs:"14px", sm:"18px"},fontWeight:"600"}}>{notification?.title}</Typography>
                    <Typography sx={{...bodyStyle,textAlign:"justify"}}>{notification?.body}</Typography>
                </Box>
                <Box sx={{display:"flex",flexDirection:"column", gap:2,}}>
                    <Typography sx={{fontSize:"10px", lineHeight:"16px", letterSpacing:"0,5px", alignSelf:"flex-end", color: colors.text.gray}}>{createdDate}</Typography>
                    <NotificationIconBox Icon={NotificationIcon} size={"47px"} iconSize={'31.33px'} />
                </Box>
                
            </Box>
            <Box sx={{width:"100%", display:"flex", justifyContent:"center"}}>
                <Divider sx={{border: 0, borderBottom: `1px solid ${colors.border.cardDiv}`,opacity: 1,mt: 1,height:"0px",backgroundColor: colors.border.cardDiv, width:"100%"}} />
            </Box>
            {/* <Typography sx={{fontSize:"14px", fontWeight:400, lineHeight:"16px",color:"#00000099"}}>{notification?.body}</Typography> */}
            
            <Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                {PriorityIcon  && <PriorityIcon />}
                <Box sx={{display:"flex", gap:1}}>
                    <Button variant="outlined" onClick={handleHide} sx={{textTransform:"capitalize", fontSize:"10px", color: colors.primary.main, border: `1px solid ${colors.primary.main}`,borderRadius:"20px", height:"32px", fontWeight:"550", padding:"0 16px" }} >{archiveStatus}</Button>
                    { notification?.userNotificationStatuses[0]?.isActive == false && <Button variant="outlined" onClick={handleDeleteClick} sx={{textTransform:"capitalize", fontSize:"10px", color: colors.error.secondary, fontWeight:"550", border: `1px solid ${colors.error.secondary}`,borderRadius:"20px", height:"32px",padding:"0 16px", '&:hover': {
                        border: `1px solid ${colors.error.secondary}`,
                        },
                        '&:focus, &.Mui-focusVisible': {
                        border: `1px solid ${colors.error.secondary}`,
                        },  }}>Delete</Button>}
                </Box>
            </Box>
            
            
        </Box> : (
            <ShimmerSkeleton variant="rectangular" width="100%" height={100} sx={{height:"250px !important"}} />
        )}
        </Box>
    </Box>
    </>
  )
}

export default NotificationDetail